export const updateCheckboxFilters = (selected, filter) => ({
  ...filter,
  selected: selected.value === filter.value ? !filter.selected : filter.selected,
})
